export function getControlType(
  tasks: { title: string; type: string; sentiments?: readonly string[] }[]
) {
  if (tasks.length === 1) {
    if (
      tasks[0].title === "" &&
      tasks[0].type === "TaskCheck" &&
      tasks[0].sentiments?.length === 1 &&
      tasks[0].sentiments[0] === "POSITIVE"
    ) {
      return "check";
    } else {
      return "checklist";
    }
  }

  if (tasks.length > 1) {
    return "checklist";
  }

  return "none";
}
